import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { BASE_URL } from '../../utils/constants';
import Navigation from '../../Layouts/Navigation/Navigation';

// Icono de mascota personalizado como SVG
const PetIcon = ({ className }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.5 3C7.12 3 6 4.12 6 5.5S7.12 8 8.5 8 11 6.88 11 5.5 9.88 3 8.5 3zm7 0C14.12 3 13 4.12 13 5.5S14.12 8 15.5 8 18 6.88 18 5.5 16.88 3 15.5 3zM3 9.25c-1.24 0-2.25 1.01-2.25 2.25S1.76 13.75 3 13.75 5.25 12.74 5.25 11.5 4.24 9.25 3 9.25zm18 0c-1.24 0-2.25 1.01-2.25 2.25s1.01 2.25 2.25 2.25S23.25 12.74 23.25 11.5 22.24 9.25 21 9.25zM12 10c-3.31 0-6 2.69-6 6 0 1.66.67 3.16 1.76 4.24l1.42-1.42C8.45 18.09 8 17.1 8 16c0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.1-.45 2.09-1.18 2.82l1.42 1.42C17.33 19.16 18 17.66 18 16c0-3.31-2.69-6-6-6z"/>
  </svg>
);

function AdminPets() {
  const [towers, setTowers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    getTowers();
  }, []);

  const getTowers = () => {
    axios.get(`${BASE_URL}/towers`)
      .then(response => setTowers(response.data))
      .catch(error => console.error('Error fetching towers:', error));
  };

  const handleTowerClick = (id_torre) => {
    navigate(`/controlPets/${id_torre}`);
  };

  const handleBack = () => {
    navigate('/dashboard');
  };

  return (
    <>
      <Navigation />
      <div className="min-h-screen bg-gradient-to-br from-green-50 via-emerald-50 to-teal-50 p-4 sm:p-6 lg:p-8">
        <div className="max-w-7xl mx-auto">
          {/* Back Button */}
          <button
            onClick={handleBack}
            className="mb-6 inline-flex items-center gap-2 px-4 py-2 bg-white text-gray-700 rounded-lg hover:bg-gray-100 transition-colors shadow-md"
          >
            <FontAwesomeIcon icon={faArrowLeft} className="h-5 w-5" />
            Volver
          </button>

          {/* Header */}
          <div className="text-center mb-12">
            <div className="flex items-center justify-center gap-3 mb-4">
              <PetIcon className="h-12 w-12 text-green-600" />
              <h1 className="text-5xl font-bold bg-gradient-to-r from-green-600 to-emerald-600 bg-clip-text text-transparent">
                Gestión de Mascotas
              </h1>
            </div>
            <p className="text-gray-600 text-lg">
              Selecciona una torre para gestionar las mascotas
            </p>
          </div>

          {/* Torre Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {towers.map((tower) => (
              <div
                key={tower.id_torre}
                onClick={() => handleTowerClick(tower.id_torre)}
                className="group cursor-pointer"
              >
                <div className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden border-2 border-transparent hover:border-green-500">
                  <div className="bg-gradient-to-br from-green-500 to-emerald-600 p-8 text-center">
                    <PetIcon className="h-16 w-16 text-white mx-auto mb-3 group-hover:scale-110 transition-transform" />
                    <h2 className="text-2xl font-bold text-white">
                      {tower.nombre}
                    </h2>
                  </div>
                  <div className="p-6 text-center">
                    <p className="text-gray-600 text-sm mb-4">
                      Click para gestionar mascotas
                    </p>
                    <div className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-lg group-hover:shadow-lg transition-shadow">
                      <span className="font-medium">Ver Mascotas</span>
                      <FontAwesomeIcon icon={faArrowLeft} className="h-4 w-4 rotate-180 group-hover:translate-x-1 transition-transform" />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {towers.length === 0 && (
            <div className="text-center py-12 bg-white rounded-2xl shadow-md">
              <FontAwesomeIcon icon={faHome} className="h-24 w-24 text-gray-300 mx-auto mb-4" />
              <p className="text-xl text-gray-500">No hay torres disponibles</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default AdminPets;

